<template>
  <a-modal
    width="40vw"
    v-model="visible"
    :title="title"
    :loading="true"
    cancelText="Zamknij"
    @cancel="closeModal"
  >
    <template #footer>
      <a-button
        v-if="isAvailable && canReserve"
        @click="reserve"
        type="primary"
        class="reserve-button"
      >
        Zarezerwuj
      </a-button>
    </template>
    <a-skeleton v-if="loading" :active="true" />
    <div v-else>
      <actions
        :calendar-slot="slot"
        @slotCancelled="slotCancelled"
        @reservationCancelled="reservationCancelled"
      />

      <availability-label :type="slot.slot_type" class="header-label" />

      <div>
        <icon-with-text v-if="slot.reserved_slot" icon="laptop">
          <strong>{{ slot.reserved_slot.course_name }}</strong>
        </icon-with-text>

        <icon-with-text icon="clock-circle">
          <span v-html="getTimespanFormatted(timespan)" />
          <div v-if="slot.availability.interval">
            {{ intervalLabel }}
          </div>
        </icon-with-text>

        <icon-with-text icon="user">
          {{ slot.availability.lecturer_str }}
        </icon-with-text>

        <icon-with-text
          v-if="!isLecturer && slot.reserved_slot && slot.reserved_slot.is_exam"
          icon="snippets"
        >
          <span>Podczas zajęć odbędzie się kartkówka</span>
        </icon-with-text>
      </div>

      <div v-if="slot.reserved_slot">
        <div v-if="isConfirmed && isLecturer" class="exam-checkbox-wrapper">
          <a-checkbox
            :checked="slot.reserved_slot.is_exam"
            @change="switchIsExam(slot.reserved_slot)"
          >
            Podczas zajęć odbędzie się kartkówka
          </a-checkbox>
        </div>

        <a-alert
          v-if="slot.reserved_slot.has_taken_place === true"
          class="banner c-small-banner mt-16"
          type="success"
          banner
        >
          <div slot="description">Obecność potwierdzona przez kursanta</div>
        </a-alert>

        <a-alert
          v-if="slot.reserved_slot.has_taken_place === false"
          class="banner c-small-banner mt-16"
          type="error"
          banner
        >
          <div slot="description">
            Kursant poinformował o nieodbyciu się zajęć.

            <div v-if="slot.reserved_slot.reason_for_not_being_present">
              <strong>Informacje dodatkowe: </strong> <br />
              {{ slot.reserved_slot.reason_for_not_being_present }}
            </div>
          </div>
        </a-alert>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { ReservationSlot, Slot } from '@/api'
import moment from 'moment'
import Actions from './Actions'
import AvailabilityLabel from '@/components/common/AvailabilityLabel'
import IconWithText from '@/components/common/IconWithText'

export default {
  data() {
    return {
      visible: false,
      slot: {
        availability: {}
      },
      loading: false
    }
  },
  components: {
    IconWithText,
    AvailabilityLabel,
    Actions
  },
  methods: {
    switchIsExam(reservedSlot) {
      this.loading = true
      ReservationSlot.toggleIsExam(reservedSlot.id)
        .then(() => {
          this.fetchSlot()
          this.$emit('examToggled')
        })
        .finally(() => {
          this.loading = false
        })
    },
    reserve() {
      this.$emit('reserve', {
        slotId: this.slot.id,
        studentId: this.getRouteParam('studentId'),
        courseId: this.getRouteParam('courseId'),
        lecturerId: this.slot.availability.lecturer,
        date: this.startMoment
      })
    },
    openModal(slotId) {
      this.loading = true
      this.slotId = slotId
      this.fetchSlot()
      this.visible = true
    },
    fetchSlot() {
      Slot.get(this.slotId, { params: { merge_slots: true } })
        .then(res => {
          this.slot = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    reservationCancelled() {
      this.$emit('calendarChanged')
      this.fetchSlot()
    },
    slotCancelled() {
      this.$emit('calendarChanged')
      this.closeModal()
    },
    closeModal() {
      this.visible = false
      this.slot = { availability: {} }
    }
  },
  computed: {
    title() {
      return this.loading
        ? true
        : this.slot.reserved_slot
        ? 'Rezerwacja'
        : 'Dostępność'
    },
    isConfirmed() {
      return this.slot.reserved_slot.status === 'confirmed'
    },
    isAvailable() {
      return this.slot.slot_type === 'available'
    },
    canReserve() {
      const hasPerm = this.isAdmin || this.isStudent
      const inFuture = this.startMoment.isAfter(moment())
      return hasPerm && inFuture
    },
    startMoment() {
      return moment(this.slot.start)
    },
    endMoment() {
      return moment(this.slot.end)
    },
    intervalLabel() {
      const intervalsMap = {
        1: 'codziennie',
        7: 'co tydzień',
        14: 'co dwa tygodnie'
      }
      const interval = this.slot.availability.interval
      const prefix = interval ? intervalsMap[interval] : ''
      return `${prefix} do ${this.intervalEndMoment.format('L')}`
    },
    intervalEndMoment() {
      const end = this.slot.availability.interval_end
      return end ? moment(end) : null
    },
    timespan() {
      return this.slot.reserved_slot
        ? this.slot.reserved_slot.timespan
        : {
            lower: this.startMoment,
            upper: this.endMoment
          }
    }
  }
}
</script>

<style scoped lang="scss">
.header-label {
  position: absolute;
  top: -54px;
  left: 116px;
}

.exam-checkbox-wrapper {
  padding: 8px 12px;
  background-color: rgba(black, 0.04);
  border-radius: 12px;
  margin-top: 16px;
}
</style>
